export const asu_valid_email_extensions = [
    'asu.edu',
    'a.asu.edu',
    'mail.asu.edu',
    'email.asu.edu',
    'my.asu.edu',
    'alumni.asu.edu',
    'wpcarey.asu.edu',
    'engineering.asu.edu',
    'scai.engineering.asu.edu',
    'ssebe.engineering.asu.edu',
    'poly.engineering.asu.edu',
    'students.engineering.asu.edu',
    'law.asu.edu',
    'chs.asu.edu',
    'asuhealth.asu.edu',
    'asuonline.asu.edu',
    'mainex1.asu.edu',
    'thesundevils.com',           
    'students.asu.edu',
    'asura.asu.edu',
    'search.asu.edu',
    'asuevents.asu.edu',
    'asu.edu/athletics',          
    'mail.asuonline.asu.edu',
    'cfo.asu.edu',
    'poly.engineering.asu.edu',
    'students.asu.edu',
    'eoss.asu.edu',
    'career.eoss.asu.edu',
    'asura.asu.edu',
    'asuhelp.asu.edu',
    'help.asu.edu',
    // Add more emails extensions here
];